export default "__VITE_PUBLIC_ASSET__0fc78690__"